import { AxiosResponse } from "axios";
import { IBioDocConfig } from "../../../common/interfaces/IBioDocConfig";
import { ErrorToast } from "../../../common/toasts/toasts";
import useQuery from "../../../utils/useQuery";
import axiosClient from "../../../common/axios/axiosConfig";

export const getConfiguration =
  (): Promise<void | AxiosResponse<IBioDocConfig>> => {
    return axiosClient
      .get(`/room/facial-recognition/configuration`, {
        headers: {
          Authorization: `Bearer ${useQuery().get("token") || ""}`,
        },
      })
      .catch(() => {
        ErrorToast.fire({
          text: "Erro ao buscar configurações",
        });
      });
  };
